<div class="sm-thankyou-screen">
  <div class="sm-thankyou-card">
    <div class="sm-check-icon">
      <i class="fa fa-check-circle"></i>
    </div>
    <h2>Submission Successful</h2>
    <p>Thank you. Your information has been submitted successfully.</p>
    <p *ngIf="agencyName">
      An agent from <strong>{{ agencyName }}</strong> will contact you shortly regarding your insurance inquiry.
    </p>
    <p *ngIf="!agencyName">
      An agent from this agency will contact you shortly regarding your insurance inquiry.
    </p>
    <hr />
    <p class="sm-close-note">You can now close this window.</p>
    <button type="button" class="btn btn-primary" (click)="closeWindow()">Close Window</button>
  </div>
</div>
